import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import { startWebConfidenceVisitorIdentitySync } from "./helpers/mergeWebConfidenceVisitorIdentity"
import "./i18n"
import "./index.css"

startWebConfidenceVisitorIdentitySync()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
